module.exports = __webpack_public_path__ + "static/media/diktat-17.f53d262b.mp3";